//
// FolderMetadata.js
// transport
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../lib";
import "./MediaType";
import "./particles/FolderType";

var FolderMetadata = createModule("transport::FolderMetadata", ["commons::PropertyOwner","commons::BaseModel","transport::TransportModel","transport::MediaType"], EventDispatcher, [
    ,
    {
        resourceId: 7,
        lastModifiedDatetime: 9,
        displayName: 7,
        created: 7,
        description: 7,
        createdDatetime: 9,
        lastModified: 7,
        shortName: 7,
        type: 4,
    },
    ,
    ,
    {
        createdUpdated: [0,1],
        lastModifiedUpdated: [0,1],
    },
    {
        _create: [4],
    },
    ,
]);
export default FolderMetadata;
